<div class="cand-modal sms-modal" *ngIf="visibility">
    <article class="cand-modal__overlay" [@slideInOut] *ngIf="visibility">
        <em class="cand-modal__overlay__close circle-close-icon" (click)="buttonCrossClick()"></em>
        <h1 class="cand-modal__title">
            <span>{{ modalTitle | i18n }}</span>
        </h1>
        <section class="cand-modal__content sms-modal__content">
            <div class="sms-modal__inputs">
                <ul>
                    <li *ngFor="let code of codeMobile">
                        <span>{{ code }}</span>
                    </li>
                </ul>
                <img class="sms-modal__inputs__arrow ng-isolate-scope" alt="" [appAssetSrc]="'assets/images/chevron-green-down.svg'" data-cand-image="assets/images/chevron-green-down.svg" />
                <img alt="" data-cand-image="assets/images/telephone-otp.svg" [appAssetSrc]="'assets/images/telephone-otp.svg'" />
            </div>
        </section>
        <footer class="cand-modal__footer">
            <p>
                <button class="button button--previous modal-info__cancel-button" (click)="buttonLeftClick()">
                    {{ buttonLeft | i18n }}
                </button>
                <button
                    class="button button--primary modal-info__next-button"
                    data-tag-commander=""
                    (click)="buttonRightClick()"
                    [ngClass]="{ 'icon--loading': loading }"
                    [appTagCommander]="'tagCo.documentselection.documentselectiontype.desktop.resendsms.button'"
                    data-api-call-button=""
                >
                    <span>{{ buttonRight | i18n }}</span>
                </button>
            </p>
        </footer>
    </article>
    <div class="cand-modal__fade" *ngIf="visibility" [@fadeInOut] (click)="buttonCrossClick()"></div>
</div>
